// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"correctStatus__wrapper__2EEvw","correct":"correctStatus__correct__3fT3g","wrong":"correctStatus__wrong__2-Pzf","title":"correctStatus__title__2X3JO"};